import { createReducer, createActions } from 'reduxsauce'
import {
  initialFeedback,
  requestFeedback,
  successFeedback,
  failureFeedback
} from './utils'

const { Types, Creators } = createActions(
  {
    getRfcRequest: [],
    getRfcSuccess: ['rfc'],

    updateRFC: ['rfc', 'formId'],
    updateRFCSuccess: ['rfc', 'formId'],
    updateRFCFailure: ['errors', 'formId'],
    updateRFCClean: ['formId'],

  },
  { prefix: 'RFC_' }
)

const INITIAL_STATE = {
  rfc: {},
  updateRFC: {
    feedback: initialFeedback(),
  },
  formFeedback: {} // Track feedback per form
}

const getRfcRequest = state => {
  return state
}

const getRfcSuccess = (state, { rfc }) => ({
  ...state,
  rfc
})

const updateRFC = (state, { formId }) => ({
  ...state,
  updateRFC: {
    ...state.updateRFC,
    feedback: requestFeedback()
  },
  formFeedback: {
    ...state.formFeedback,
    [formId]: requestFeedback()
  }
})

const updateRFCSuccess = (state, { rfc, formId }) => ({
 ...state,
  rfc,
  updateRFC: {
   ...state.updateRFC,
    feedback: successFeedback(),
  },
  formFeedback: {
    ...state.formFeedback,
    [formId]: successFeedback()
  }
})

const updateRFCFailure = (state, { errors, formId }) => ({
 ...state,
  updateRFC: {
   ...state.updateRFC,
    feedback: failureFeedback(errors)
  },
  formFeedback: {
    ...state.formFeedback,
    [formId]: failureFeedback(errors)
  }
})

const updateRFCClean = (state, { formId }) => ({
 ...state,
  updateRFC: {
   ...state.updateRFC,
    feedback: formId ? state.updateRFC.feedback : initialFeedback()
  },
  formFeedback: {
    ...state.formFeedback,
    [formId]: initialFeedback()
  }
})


const HANDLERS = {
  [Types.GET_RFC_REQUEST]: getRfcRequest,
  [Types.GET_RFC_SUCCESS]: getRfcSuccess,

  [Types.UPDATE_RFC]: updateRFC,
  [Types.UPDATE_RFC_SUCCESS]: updateRFCSuccess,
  [Types.UPDATE_RFC_FAILURE]: updateRFCFailure,
  [Types.UPDATE_RFC_CLEAN]: updateRFCClean,
}

export const RfcActionTypes = Types

export const RfcActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
